import React from "react";
const SectionBadge = ({ label, editable }) => (
  <div className="flex items-center justify-between mb-3">
    <span className="text-xs font-bold uppercase tracking-widest text-gray-400">{label}</span>
    <span className={`text-[10px] px-2 py-1 rounded-full font-semibold border ${editable ? "bg-green-200 text-green-700 border-green-200" : "bg-gray-200 text-gray-500 border-gray-200"}`}>
      {editable ? "Editable" : "View Only"}
    </span>
  </div>
);
export default SectionBadge;